import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';

import { CollectionVM } from '../../utility/models/collection-vm';

@Component({
  selector: 'collection-card',
  templateUrl: './collection-card.component.html',
  styleUrls: ['./collection-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CollectionCardComponent {
  @Input() collection: CollectionVM;
  @Output() select = new EventEmitter<CollectionVM>();

  handleClick() {
    this.select.emit(this.collection);
  }
}
